module.exports = __webpack_public_path__ + "assets/ffbd969ecf31645038f8c827b04d1b2b.mp3";